/* LUVERRE Runde 4 – Helfer, Gravur-Animation, Welten-Film und Start. */
(function () {
  'use strict';
  var L = (window.LV = {});
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  L.reduce = reduce;
  L.clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  L.lerp = function (a, b, t) { return a + (b - a) * t; };
  L.range = function (p, a, b) { return L.clamp((p - a) / (b - a), 0, 1); };
  L.ease = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  L.easeOut = function (t) { return 1 - Math.pow(1 - t, 3); };
  L.window = function (p, a, b, f) {
    f = f || 0.22;
    var span = b - a, i = L.range(p, a, a + span * f), o = 1 - L.range(p, b - span * f, b);
    return Math.min(i, o);
  };
  L.load = function (src) {
    return new Promise(function (res) {
      if (!src) { res(null); return; }
      var im = new Image();
      im.decoding = 'async';
      im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); };
      im.onerror = function () { res(null); };
      im.src = src;
    });
  };
  L.fit = function (cv) {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = cv.clientWidth, h = cv.clientHeight;
    var W = Math.round(w * dpr), H = Math.round(h * dpr);
    if (cv.width !== W || cv.height !== H) {
      cv.width = W; cv.height = H;
      cv.getContext('2d').setTransform(dpr, 0, 0, dpr, 0, 0);
      return true;
    }
    return false;
  };
  L.progress = function (sec) {
    var r = sec.getBoundingClientRect();
    var total = sec.offsetHeight - window.innerHeight;
    return total > 0 ? L.clamp(-r.top / total, 0, 1) : 0;
  };
  L.feather = function (ctx, x, y, w, h, cw, ch, color, amt) {
    amt = amt || 0.16;
    var c0 = color, c1 = color.replace(/[\d.]+\)$/, '0)');
    var f = Math.min(w, h) * amt, g;
    ctx.fillStyle = c0;
    if (x > -f) { g = ctx.createLinearGradient(x, 0, x + f, 0); g.addColorStop(0, c0); g.addColorStop(1, c1); ctx.fillStyle = g; ctx.fillRect(x - 1, y - 1, f + 1, h + 2); }
    if (x + w < cw + f) { g = ctx.createLinearGradient(x + w, 0, x + w - f, 0); g.addColorStop(0, c0); g.addColorStop(1, c1); ctx.fillStyle = g; ctx.fillRect(x + w - f, y - 1, f + 1, h + 2); }
    if (y > -f) { g = ctx.createLinearGradient(0, y, 0, y + f); g.addColorStop(0, c0); g.addColorStop(1, c1); ctx.fillStyle = g; ctx.fillRect(x - 1, y - 1, w + 2, f + 1); }
    if (y + h < ch + f) { g = ctx.createLinearGradient(0, y + h, 0, y + h - f); g.addColorStop(0, c0); g.addColorStop(1, c1); ctx.fillStyle = g; ctx.fillRect(x - 1, y + h - f, w + 2, f + 1); }
  };
  var toastEl, toastT;
  L.toast = function (msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'lv-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('on'); }, 2600);
  };
  function money(c) { return (c % 100 === 0) ? (c / 100) + ' €' : (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  L.buy = function (root) {
    if (!root) return;
    var cb = root.querySelector('[data-gravur]'), field = root.querySelector('[data-gravur-field]');
    var prices = document.querySelectorAll('[data-price]:not([data-buy])');
    var input = root.querySelector('[data-gravur-input]'), count = root.querySelector('[data-count]');
    var base = parseInt(root.dataset.price || '0', 10), gp = parseInt(root.dataset.gravurPrice || '0', 10);
    function upd() {
      var on = cb && cb.checked;
      if (field) field.hidden = !on;
      prices.forEach(function (p) { p.textContent = money(base + (on ? gp : 0)); });
    }
    if (cb) cb.addEventListener('change', upd);
    if (input && count) input.addEventListener('input', function () { count.textContent = input.value.length + ' / 40'; });
    document.querySelectorAll('[data-cart]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (root.dataset.available !== 'true') { L.toast((window.LVT && LVT.unavail) || 'Derzeit nicht verfügbar.'); return; }
        var items = [{ id: parseInt(root.dataset.vid, 10), quantity: parseInt(root.dataset.qty || '1', 10) }];
        if (cb && cb.checked) {
          var txt = input ? input.value.trim() : '';
          if (!txt) { L.toast('Bitte gib deinen Gravurtext ein.'); if (input) input.focus(); return; }
          items[0].properties = { 'Gravur': txt };
          if (root.dataset.gravurVid) items.push({ id: parseInt(root.dataset.gravurVid, 10), quantity: 1, properties: { 'Gravurtext': txt } });
        }
        var old = b.textContent; b.textContent = (window.LVT && LVT.adding) || 'Wird hinzugefügt …'; b.style.pointerEvents = 'none';
        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) { if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Fehler'); window.location.href = (window.routes && window.routes.cart_url) || '/cart'; })
          .catch(function (ex) { b.textContent = old; b.style.pointerEvents = ''; L.toast(((window.LVT && LVT.failed) || 'Das hat nicht geklappt: ') + ex.message); });
      });
    });
    upd();
  };
  L.sticky = function (bar, showAfterPx, hideEl) {
    if (!bar) return;
    function upd() {
      var y = window.scrollY, show = y > showAfterPx();
      [].concat(hideEl || []).forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight && r.bottom > 0) show = false; });
      bar.classList.toggle('on', show);
    }
    window.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  };
  L.reveal = function () {
    if (reduce || !('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll('[data-reveal]');
    els.forEach(function (el) { if (el.dataset.rv) return; el.dataset.rv = '1'; var r = el.getBoundingClientRect(); if (r.top > window.innerHeight) el.classList.add('pre'); });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.remove('pre'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  };
})();

/* »So funktioniert's«: vom Produktbild in ein Detail des Motivs, das Motiv zerfällt in Lichtpunkte, Licht wandert von der Kante durchs Glas. */
(function () {
  'use strict';
  window.LVGlow2 = function (sec) {
    if (!sec) return;
    var cv = sec.querySelector('canvas'), ctx = cv.getContext('2d'), ds = sec.dataset;
    var FX = +ds.fx, FY = +ds.fy, REG = +ds.reg;
    var beats = [].slice.call(sec.querySelectorAll('.gbeat')).map(function (el) { return { el: el, a: +el.dataset.a, b: +el.dataset.b }; });
    var main = null, white = null, warm = null, sparks = [], off = document.createElement('canvas'), octx = off.getContext('2d'), visible = false;
    var BG = '#120f0c';
    LV.load(ds.main).then(function (i) { main = i; });
    LV.load(ds.mw).then(function (i) {
      if (!i) return; white = i;
      try {
        var s = document.createElement('canvas'); s.width = 160; s.height = 160; var g = s.getContext('2d'); g.drawImage(i, 0, 0, 160, 160);
        var d = g.getImageData(0, 0, 160, 160).data, cand = [];
        for (var y = 0; y < 160; y++) for (var x = 0; x < 160; x++) { var v = d[(y * 160 + x) * 4]; if (v > 70 && Math.hypot(x / 160 - .5, y / 160 - .5) < 0.4) cand.push([x / 160, y / 160]); }
        for (var k = 0; k < 380 && cand.length; k++) { var c = cand[Math.floor(Math.random() * cand.length)]; sparks.push({ x: c[0], y: c[1], ph: Math.random() * 6.28, sp: .6 + Math.random() * 1.6, r: .6 + Math.random() * 1.3 }); }
      } catch (e) {}
    });
    LV.load(ds.mg).then(function (i) { warm = i; });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { rootMargin: '120px' }).observe(sec);
    else visible = true;
    function draw(p, t) {
      LV.fit(cv);
      var W = cv.clientWidth, H = cv.clientHeight; ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over';
      ctx.fillStyle = BG; ctx.fillRect(0, 0, W, H);
      var portrait = W / H < 0.95;
      var bw0 = H;
      var bx = portrait ? LV.clamp(W / 2 - FX * bw0, W - bw0, 0) : W * 0.62 - bw0 * 0.5;
      var sx = bx + FX * bw0, sy = FY * bw0;
      var tx = portrait ? W / 2 : W * 0.62, ty = portrait ? H * 0.4 : H * 0.5;
      var a = LV.ease(LV.range(p, .03, .17)), cx = LV.lerp(sx, tx, a), cy = LV.lerp(sy, ty, a);
      var target = portrait ? W * 1.02 : Math.min(H * 0.92, W * 0.5);
      var zmax = target / (REG * bw0), zt = LV.ease(LV.range(p, .04, .32)), z = Math.pow(zmax, zt);
      var iw = bw0 * z;
      var ra = 1 - LV.range(p, .27, .37);
      if (main && ra > 0) {
        ctx.globalAlpha = ra; ctx.drawImage(main, cx - FX * iw, cy - FY * iw, iw, iw); ctx.globalAlpha = 1;
        if (!portrait) LV.feather(ctx, cx - FX * iw, cy - FY * iw, iw, iw, W, H, 'rgba(18,15,12,1)', .14);
        var vd = LV.range(p, .08, .32);
        if (vd > 0) { var g = ctx.createRadialGradient(cx, cy, Math.min(W, H) * (0.6 - 0.32 * vd), cx, cy, Math.max(W, H) * 0.8); g.addColorStop(0, 'rgba(18,15,12,0)'); g.addColorStop(1, 'rgba(18,15,12,' + (0.96 * vd).toFixed(3) + ')'); ctx.fillStyle = g; ctx.fillRect(0, 0, W, H); }
      }
      var grow = 1 + 0.22 * LV.ease(LV.range(p, .32, .7)) - 0.06 * LV.ease(LV.range(p, .8, 1));
      var ms = REG * iw * grow, mx = cx - ms / 2, my = cy - ms / 2;
      var ma = LV.range(p, .22, .35);
      if (white && ma > 0) { ctx.globalCompositeOperation = 'lighter'; ctx.globalAlpha = ma * (0.8 - 0.3 * LV.range(p, .4, .5)); ctx.drawImage(white, mx, my, ms, ms); ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over'; }
      var sw = LV.range(p, .4, .7);
      if (warm && sw > 0) {
        if (off.width !== cv.width || off.height !== cv.height) { off.width = cv.width; off.height = cv.height; }
        var dpr = cv.width / W; octx.setTransform(dpr, 0, 0, dpr, 0, 0); octx.globalCompositeOperation = 'source-over'; octx.clearRect(0, 0, W, H);
        octx.drawImage(warm, mx, my, ms, ms);
        octx.globalCompositeOperation = 'destination-in';
        var band = W * 0.35, front = -band + (W + 2 * band) * LV.ease(sw);
        var gg = octx.createLinearGradient(front - band, 0, front + band * 0.3, 0);
        gg.addColorStop(0, 'rgba(0,0,0,1)'); gg.addColorStop(0.75, 'rgba(0,0,0,1)'); gg.addColorStop(1, 'rgba(0,0,0,0)');
        octx.fillStyle = gg; octx.fillRect(0, 0, W, H);
        ctx.globalCompositeOperation = 'lighter'; ctx.globalAlpha = .9; ctx.drawImage(off, 0, 0, W, H); ctx.globalAlpha = 1;
        if (sw < 1) { var lf = ctx.createLinearGradient(front - 40, 0, front + 40, 0); lf.addColorStop(0, 'rgba(255,214,150,0)'); lf.addColorStop(.5, 'rgba(255,214,150,' + (0.2 * Math.sin(sw * Math.PI)).toFixed(3) + ')'); lf.addColorStop(1, 'rgba(255,214,150,0)'); ctx.fillStyle = lf; ctx.fillRect(front - 40, 0, 80, H); }
        ctx.globalCompositeOperation = 'source-over';
      }
      var ed = LV.range(p, .36, .42);
      if (ed > 0) { var eg = ctx.createLinearGradient(0, 0, 26, 0); eg.addColorStop(0, 'rgba(255,226,180,' + (0.9 * ed).toFixed(3) + ')'); eg.addColorStop(1, 'rgba(255,226,180,0)'); ctx.fillStyle = eg; ctx.fillRect(0, 0, 26, H); }
      var tw = LV.range(p, .66, .76);
      if (tw > 0 && sparks.length) {
        ctx.globalCompositeOperation = 'lighter';
        for (var i = 0; i < sparks.length; i++) {
          var q = sparks[i], al = Math.pow(Math.max(0, Math.sin(t * q.sp + q.ph)), 6) * tw;
          if (al < 0.02) continue; var px = mx + q.x * ms, py = my + q.y * ms;
          var rg = ctx.createRadialGradient(px, py, 0, px, py, 7 * q.r); rg.addColorStop(0, 'rgba(255,240,215,' + al.toFixed(3) + ')'); rg.addColorStop(1, 'rgba(255,200,130,0)');
          ctx.fillStyle = rg; ctx.beginPath(); ctx.arc(px, py, 7 * q.r, 0, 6.283); ctx.fill();
        }
        ctx.globalCompositeOperation = 'source-over';
      }
    }
    var last = '';
    function tick(now) {
      if (visible) {
        var p = LV.progress(sec), t = now / 1000, key = p.toFixed(4) + cv.clientWidth + 'x' + cv.clientHeight + (main ? 1 : 0) + (white ? 1 : 0) + (warm ? 1 : 0);
        if (key !== last || p > .66) {
          last = key; draw(p, t);
          var desk = innerWidth >= 900 && innerWidth > innerHeight;
          beats.forEach(function (b) { var o = LV.window(p, b.a, b.b, .22); b.el.style.opacity = o.toFixed(3); b.el.style.transform = (desk ? 'translateY(-50%) ' : '') + 'translateY(' + ((1 - o) * 12 * (p < (b.a + b.b) / 2 ? 1 : -1)).toFixed(1) + 'px)'; });
        }
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  };
})();

/* Startseite »Welche Welt ist deine?«: Die Leuchte steht immer an derselben Stelle, um sie herum wechselt die Welt (WebGL-Tiefe). */
window.LVFilm = function (film) {
  'use strict';
  var data = film.querySelector('script[type="application/json"]');
  var WORLDS = data ? JSON.parse(data.textContent) : [];
  var cv = film.querySelector('canvas'), hero = film.querySelector('.hero');
  if (!WORLDS.length || !cv) return;
  var dots = [].slice.call(film.querySelectorAll('.dots4 i')), dotsBox = film.querySelector('.dots4');
  var beats = [].slice.call(film.querySelectorAll('.beat')).map(function (el) { return { el: el, a: +el.dataset.a, b: +el.dataset.b, final: el.classList.contains('final') }; });
  var S0 = .045, SL = .172, BG = [244 / 255, 240 / 255, 234 / 255], AR = 2.5;
  var gl = cv.getContext('webgl', { antialias: false, premultipliedAlpha: false });
  var tex = [], dep = [], imgs = [], prog, loc = {};
  function sh(t, src) { var s = gl.createShader(t); gl.shaderSource(s, src); gl.compileShader(s); if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) console.error(gl.getShaderInfoLog(s)); return s; }
  var VS = 'attribute vec2 p; varying vec2 v; void main(){ v=vec2(p.x*.5+.5,.5-p.y*.5); gl_Position=vec4(p,0.,1.); }';
  var FS = [
    'precision highp float; varying vec2 v;',
    'uniform sampler2D tA,dA,tB,dB; uniform vec4 rA,rB; uniform vec2 uRes,uL,uCam,uFY,uFX,uFT; uniform float uZoom,uMix,fA,fB; uniform vec3 uBg;',
    'vec4 W(sampler2D T,sampler2D D,float f,vec4 r,vec2 px){ vec2 uv=(px-r.xy)/r.zw; vec2 c=clamp(uv,0.,1.); float d=texture2D(D,c).r; vec2 q=uv;',
    '  for(int i=0;i<4;i++){ q=uv+uCam*(d-f); d=texture2D(D,clamp(q,0.,1.)).r; }',
    '  q=uv+uCam*(d-f); vec3 col=texture2D(T,clamp(q,.001,.999)).rgb;',
    '  float a=smoothstep(0.,.07,uv.x)*smoothstep(1.,.93,uv.x)*smoothstep(0.,.07,uv.y)*smoothstep(1.,.9,uv.y); return vec4(col,a); }',
    'void main(){ vec2 px=v*uRes; px=uL+(px-uL)/uZoom;',
    '  vec4 a=W(tA,dA,fA,rA,px); vec4 b=W(tB,dB,fB,rB,px);',
    '  vec3 c=mix(mix(uBg,a.rgb,a.a),mix(uBg,b.rgb,b.a),uMix);',
    '  float s=(1.-smoothstep(uFY.x,uFY.y,v.y))*(1.-smoothstep(uFX.x,uFX.y,v.x))*smoothstep(uFT.x,uFT.y,v.y);',
    '  gl_FragColor=vec4(mix(uBg,c,s),1.); }'].join('\n');
  if (gl) {
    prog = gl.createProgram(); gl.attachShader(prog, sh(gl.VERTEX_SHADER, VS)); gl.attachShader(prog, sh(gl.FRAGMENT_SHADER, FS)); gl.linkProgram(prog); gl.useProgram(prog);
    var buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf); gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    var pl = gl.getAttribLocation(prog, 'p'); gl.enableVertexAttribArray(pl); gl.vertexAttribPointer(pl, 2, gl.FLOAT, false, 0, 0);
    ['tA', 'dA', 'tB', 'dB', 'rA', 'rB', 'uRes', 'uL', 'uCam', 'uFY', 'uFX', 'uFT', 'uZoom', 'uMix', 'fA', 'fB', 'uBg'].forEach(function (n) { loc[n] = gl.getUniformLocation(prog, n); });
    gl.uniform1i(loc.tA, 0); gl.uniform1i(loc.dA, 1); gl.uniform1i(loc.tB, 2); gl.uniform1i(loc.dB, 3);
  }
  function mk(img) { var t = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, t);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, img); return t; }
  WORLDS.forEach(function (w, i) {
    Promise.all([LV.load(w.img), LV.load(w.dep)]).then(function (r) {
      imgs[i] = r[0]; if (gl && r[0] && r[1]) { try { tex[i] = mk(r[0]); dep[i] = mk(r[1]); } catch (e) { console.error(e); } }
    });
  });
  function layout(W, H) {
    var portrait = W / H < 0.95, desk = !portrait && W >= 900;
    if (portrait) return { cx: W / 2, top: H * 0.125, h: H * 0.43, fy: [.6, .67], fx: [2, 3], ft: [.075, .13], portrait: true };
    if (desk) return { cx: W * 0.31, top: H * 0.15, h: H * 0.66, fy: [2, 3], fx: [.54, .7], ft: [-1, -.5], portrait: false };
    return { cx: W * 0.33, top: H * 0.14, h: H * 0.66, fy: [2, 3], fx: [.6, .74], ft: [-1, -.5], portrait: false };
  }
  function rect(w, L) {
    var ih = L.h / (w.y1 - w.y0), iw = ih * AR;
    return [L.cx - w.cx * iw, L.top - w.y0 * ih, iw, ih];
  }
  function seg(p) {
    var x = (p - S0) / SL; if (x < 0) return [0, 0, 0, 0];
    var i = Math.min(4, Math.floor(x)), t = x - i;
    if (i >= 4) return [4, 4, 0, Math.min(1, t)];
    return [i, i + 1, LV.ease(LV.range(t, .72, 1)), t];
  }
  function draw(p, time) {
    var W = cv.clientWidth, H = cv.clientHeight, dpr = Math.min(window.devicePixelRatio || 1, 2);
    if (cv.width !== Math.round(W * dpr) || cv.height !== Math.round(H * dpr)) { cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr); }
    var s = seg(p), a = s[0], b = s[1], m = s[2], t = s[3], L = layout(W, H);
    var u = p < S0 ? 0 : t, sway = LV.lerp(-1, 1, LV.ease(Math.min(1, u * 1.1))), idle = Math.sin(time * 0.45) * 0.2;
    var camX = (sway * 0.018 + idle * 0.005), camY = Math.sin(u * Math.PI) * 0.004 + Math.cos(time * 0.35) * 0.001;
    var zoom = 1 + 0.06 * Math.sin(Math.min(1, u) * Math.PI) + (p < S0 ? 0.01 * Math.sin(time * 0.4) : 0);
    dots.forEach(function (d, k) { d.classList.toggle('on', k === (m > .5 ? b : a)); });
    if (dotsBox) dotsBox.style.opacity = p > S0 && p < .9 ? 1 : 0;
    var lx = L.cx, ly = L.top + L.h * 0.55;
    if (!gl || !tex[a]) {
      var c2 = !gl && cv.getContext('2d'); if (!c2 || !imgs[a]) return;
      c2.setTransform(dpr, 0, 0, dpr, 0, 0); c2.fillStyle = '#f4f0ea'; c2.fillRect(0, 0, W, H);
      var ra = rect(WORLDS[a], L); c2.drawImage(imgs[a], ra[0], ra[1], ra[2], ra[3]);
      if (m > 0 && imgs[b]) { var rb = rect(WORLDS[b], L); c2.globalAlpha = m; c2.drawImage(imgs[b], rb[0], rb[1], rb[2], rb[3]); c2.globalAlpha = 1; }
      return;
    }
    var bb = tex[b] ? b : a, RA = rect(WORLDS[a], L), RB = rect(WORLDS[bb], L);
    gl.viewport(0, 0, cv.width, cv.height);
    gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_2D, tex[a]); gl.activeTexture(gl.TEXTURE1); gl.bindTexture(gl.TEXTURE_2D, dep[a]);
    gl.activeTexture(gl.TEXTURE2); gl.bindTexture(gl.TEXTURE_2D, tex[bb]); gl.activeTexture(gl.TEXTURE3); gl.bindTexture(gl.TEXTURE_2D, dep[bb]);
    gl.uniform4f(loc.rA, RA[0], RA[1], RA[2], RA[3]); gl.uniform4f(loc.rB, RB[0], RB[1], RB[2], RB[3]);
    gl.uniform2f(loc.uRes, W, H); gl.uniform2f(loc.uL, lx, ly); gl.uniform2f(loc.uCam, camX, camY);
    gl.uniform2f(loc.uFY, L.fy[0], L.fy[1]); gl.uniform2f(loc.uFT, L.ft[0], L.ft[1]); gl.uniform2f(loc.uFX, L.fx[0], L.fx[1]);
    gl.uniform1f(loc.uZoom, zoom); gl.uniform1f(loc.uMix, bb === a ? 0 : m); gl.uniform1f(loc.fA, WORLDS[a].foc); gl.uniform1f(loc.fB, WORLDS[bb].foc);
    gl.uniform3f(loc.uBg, BG[0], BG[1], BG[2]);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
  }
  function tick(now) {
    var p = LV.progress(film), r = film.getBoundingClientRect();
    if (r.bottom > 0 && r.top < window.innerHeight) {
      draw(p, now / 1000);
      var desk = window.innerWidth >= 900 && window.innerWidth > window.innerHeight, base = desk ? 'translateY(-50%) ' : '';
      var h = 1 - LV.range(p, 0, .035); if (hero) { hero.style.opacity = h; hero.style.visibility = h <= 0 ? 'hidden' : 'visible'; hero.style.transform = base + 'translateY(' + (-14 * (1 - h)) + 'px)'; }
      beats.forEach(function (b) { var o = LV.window(p, b.a, b.b, b.final ? .12 : .2), dy = (1 - o) * 12 * (p < (b.a + b.b) / 2 ? 1 : -1);
        b.el.style.opacity = o.toFixed(3); b.el.style.transform = base + 'translateY(' + dy.toFixed(1) + 'px)'; b.el.classList.toggle('live', o > .5); });
    }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
};

/* Start: alle Runde-4-Bausteine auf der Seite */
(function () {
  function boot() {
    document.querySelectorAll('.film').forEach(function (f) { if (!f.dataset.init) { f.dataset.init = '1'; LVFilm(f); } });
    document.querySelectorAll('.glow-sec').forEach(function (s) { if (!s.dataset.init) { s.dataset.init = '1'; LVGlow2(s); } });
    document.querySelectorAll('.gal').forEach(function (g) {
      if (g.dataset.init) return; g.dataset.init = '1';
      var tr = g.querySelector('.track'), th = [].slice.call(g.querySelectorAll('.thumbs button')), cnt = g.querySelector('.cnt');
      function cur() { return Math.round(tr.scrollLeft / tr.clientWidth); }
      tr.addEventListener('scroll', function () { var i = cur(); th.forEach(function (b, j) { b.classList.toggle('on', i === j); }); if (cnt) cnt.textContent = (i + 1) + ' / ' + th.length; }, { passive: true });
      th.forEach(function (b, j) { b.addEventListener('click', function () { tr.scrollTo({ left: j * tr.clientWidth, behavior: 'smooth' }); }); });
    });
    var buy = document.querySelector('[data-buy]'); if (buy && !buy.dataset.init) { buy.dataset.init = '1'; LV.buy(buy); }
    var bar = document.getElementById('sbar');
    if (bar && !bar.dataset.init) {
      bar.dataset.init = '1';
      var film = document.querySelector('.film'), kaufen = document.getElementById('kaufen'), hide = [];
      ['welten', 'so-gehts', 'kaufen'].forEach(function (id) { var el = document.getElementById(id); if (el) hide.push(el); });
      LV.sticky(bar, function () { if (film) return film.offsetTop + film.offsetHeight - innerHeight * 0.5; if (kaufen) return kaufen.offsetTop + kaufen.offsetHeight * 0.8; return 600; }, hide);
    }
    LV.reveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
